import { CODE_TYPE, DEVICE_TYPE, PAYMENT_TYPES, RESTRICTION_TYPE } from "../../../Common/constants";
import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/en";
import { formatEpochTimeSeconds, isEpochTimeBeforeNow } from "./utils";

export default {
  locale: "en",
  name: "Payment Types",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "type",
        displayName: "Payment type",
      },
      {
        fieldName: "title",
        displayName: "Title",
      },
      {
        fieldName: "minRelease",
        displayName: "Min. release (hrs)",
      },
      {
        fieldName: "maxRelease",
        displayName: "Max. release (hrs)",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "type",
      },
      {
        fieldName: "merchantId",
        displayName: "Merchant Id",
      },
      {
        fieldName: "merchantPassword",
        displayName: "Merchant Password",
      },
      {
        fieldName: "merchantAccount",
        displayName: "Merchant Account",
      },
      {
        fieldName: "publicApiKey",
        displayName: "Client Key",
      },
      {
        fieldName: "prefix",
        displayName: "Production Prefix",
      },
      {
        fieldName: "installmentsIsActive",
        displayName: "Installments is active?",
      },
      {
        fieldName: "installmentsValues",
        displayName: "Installments values",
      },
      {
        fieldName: "secret",
        displayName: ({ formValues }) =>
          formValues.type === PAYMENT_TYPES.CRIPTAN ? "Secret" : "Key",
      },
      {
        fieldName: "rebatePassword",
        displayName: "Rebate password",
      },
      {
        fieldName: "pnpClient",
        displayName: "Client",
      },
      {
        fieldName: "pnpGateway",
        displayName: "Payment letter",
      },
      {
        fieldName: "key",
        displayName: "Key",
      },
      {
        fieldName: "clave256",
        displayName: "Encryption key",
      },
      {
        fieldName: "Ds_Merchant_MerchantCode",
        displayName: "MerchantCode",
      },
      {
        fieldName: "Ds_Merchant_Terminal",
        displayName: "MerchantTerminal",
      },
      {
        fieldName: "Ds_Merchant_Currency",
        displayName: "MerchantCurrency",
      },
      {
        fieldName: "Ds_Merchant_MerchantURL",
      },
      {
        fieldName: "url",
        displayName: "Url",
        helpText:
          'Url test "https://sis-t.redsys.es:25443/sis/realizarPago" / producción https://sis.redsys.es/sis/realizarPago',
      },
      {
        fieldName: "clientId",
        displayName: "Client",
      },
      {
        fieldName: "description",
        displayName: "Description",
      },
      {
        fieldName: "descriptionWithDeposit",
        displayName: "Description for deposit",
      },
      {
        fieldName: "descriptionWithoutDeposit",
        displayName: "Description without deposit",
      },
      {
        fieldName: "roomLockHours",
        displayName: "Availability blocking",
        helpText: "# of hours that the booking is saved for the client",
      },
      {
        fieldName: "automaticCancellation",
        displayName: "Automatically cancel all reservations that have expired blocking",
      },
      {
        fieldName: "minDuration",
        displayName: "Min. release (hrs)",
        helpText:
          "If the release is lower it does not allow the user to select this type of payment",
      },
      {
        fieldName: "maxDuration",
        displayName: "Max. release (hrs)",
        helpText:
          "If the release is higher it does not allow the user to select this type of payment",
      },
      {
        fieldName: "codesSection",
        displayName: "Code",
        helpText:
          "Only when this code has been entered in the booking engine the payment method will activated.",
      },
      {
        fieldName: "codeType",
        displayName: "",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "No code",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Universal code",
          },
        },
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "Device type",
        widget: "multicheckbox",
        defaultValue: [],
        selectables: true,
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Desktop",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablet",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Mobile",
          },
        ],
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "paymentMethods",
        displayName: "Payment Methods",
        helpText: "If the field is empty, all available payment methods will be applied",
      },
      {
        fieldName: "accountType",
        displayName: "Account",
        helpText: "Only a new account or an account linked to Septeo/Tesipro can be linked",
        helpTextClassName: "text-red-500",
        options: [
          {
            value: "-",
            label: "-",
          },
          {
            value: "NEW",
            label: "Create new account",
          },
          {
            value: "EXISTING",
            label: "Link Septeo/Tesipro account",
          },
        ],
      },
      {
        fieldName: "stripeAccountButton",
        displayBtn: "Create linked account",
      },
      {
        fieldName: "accountLink",
        displayName: "Account onboarding link",
        transform: ({ field, formValues }) => {
          const isExpired = isEpochTimeBeforeNow(formValues.accountLinkExpiresAt);
          const { date, time } = formatEpochTimeSeconds(formValues.accountLinkExpiresAt);

          return {
            ...field,
            helpText: isExpired
              ? "The link has expired, you must regenerate a new link."
              : `Link expires at: ${time} h on ${date}`,
            helpTextClassName: "text-red-500",
          };
        },
      },
      {
        fieldName: "stripeAccountLinkButton",
        displayBtn: "Regenerate link",
      },
      {
        fieldName: "componentType",
        displayName: "Component",
      },
    ],
  },
};
